'use client';

import { useEffect } from 'react';
import Router from 'next/router';
import { useNewCSRFToken } from '@/hooks/useNewCSRFToken';
import { useBodyClasses } from '@/hooks/useBodyClasses';
import { useBackNavigation } from '@/hooks/useBackNavigation';
import { initializeGoogleTagManager } from '@/utils/googleTagManager';
import { CONFIG } from '@/constants/config';
import { noTopInsert } from '@/bridge/utils/noTopInsert';
import { useLoginUser } from '@/hooks/useLoginUser';
import { useLSBookmarks } from '@/hooks/useLSBookmarks';

interface ClientWrapperProps {
  children: React.ReactNode;
  isSSRWebView?: boolean;
}

export function ClientWrapper({ children, isSSRWebView }: ClientWrapperProps) {
  const csrfToken = useNewCSRFToken();
  useBodyClasses();
  useBackNavigation();
  const isLoginInProgress = useLoginUser();
  const isLSBookmarksChecked = useLSBookmarks();

  useEffect(() => {
    initializeGoogleTagManager(CONFIG.gtmContainerId);

    if (isSSRWebView) {
      noTopInsert();
      Router.events.on('beforeHistoryChange', noTopInsert);
    }

    if (!document.querySelector('script[src*="gpt.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
      script.async = true;
      document.head.appendChild(script);
    }

    return () => {
      if (isSSRWebView) {
        Router.events.off('beforeHistoryChange', noTopInsert);
      }
    };
  }, [isSSRWebView]);

  if (!csrfToken || isLoginInProgress || !isLSBookmarksChecked) {
    return null;
  }

  return <>{children}</>;
}
